export const compareByWalkTime = (a, b) => {
  const aTime = a.timeByWalk;
  const bTime = b.timeByWalk;

  if (aTime < bTime) {
    return -1;
  } else if (aTime > bTime) {
    return 1;
  } else {
    return 0;
  }
};
